<template>
  <div class="picker-container">
    <div>
      <a @click="chooseOption(option)" class="dropdown-item" v-for="option in availableConditions" :key="option.id">
        <Icon :icon="getIconComponent(option)" />
        <span class="item-title">{{ option.title }}</span>
      </a>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ConditionViewModel } from './models/conditionViewModel';
import { ConditionPickerOption } from './models/conditions';
import Icon from '@/shared/icons/Icon.vue';
import { Icons } from '@/shared/icons/icons';
import { PropType } from 'vue';

defineProps({
  availableConditions: {
    type: Array as PropType<ConditionPickerOption[]>,
    required: true,
  },
});

const emit = defineEmits<{
  (e: 'selected', condition: ConditionViewModel): void;
}>();

function getIconComponent(option: ConditionPickerOption): keyof typeof Icons {
  if (option && option.icon) {
    return option.icon;
  }

  return 'CustomAttributeIcon';
}

function chooseOption(option: ConditionPickerOption) {
  const condition: ConditionViewModel = {
    attribute: option.id,
    operation: '',
    type: option.type,
    unit: '',
    value: '',
    result: true,
  };

  emit('selected', condition);
}
</script>

<style scoped lang="scss">
.dropdown-divider {
  background-color: #ededed;
  border: none;
  display: block;
  height: 1px;
  margin: 0.5rem 0;
}

.picker-container {
  position: absolute;
  min-width: 300px;
  background: white;
  top: 40px;
  z-index: 10;

  border-radius: 4px;
  box-shadow:
    0 3px 8px 0 rgba(0, 0, 0, 0.1),
    0 0 0 1px rgba(10, 10, 10, 0.1);
  padding-bottom: 0.5rem;
  padding-top: 0.5rem;
  padding: 0.5rem;
  max-height: 300px;
  overflow: auto;

  visibility: visible;

  &.hidden {
    visibility: hidden;
  }
}

.item-title {
  padding-left: 0.75em;
}

.dropdown-item {
  color: $color-netcall-body-text;
}
</style>
